import { ROUTES } from '#/config/routes';
import { createDocumentNavLinksColumn } from '#/modules/commonComponents/table/tableColumnHelpers';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import {
  formatCostEstimateDecimal,
  formatCostEstimateRoundingMode,
  formatCostEstimateTotal,
} from '#/modules/crmMgmt/costEstimate/helper/costEstimateFormat';
import { formatDateTimeOrDash } from '#/utils/date';

function displayDash(value) {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
}

/** 後端搜尋只收 keyword／sort／page；欄位不開篩選，排序只有 name／updated_at。 */
export function buildCostEstimateColumns({ canShowEdit = () => true } = {}) {
  return [
    createDocumentNavLinksColumn({
      getDetailPath: (row) => ROUTES.costEstimateDetail(row.id),
      getEditPath: (row) => ROUTES.costEstimateEdit(row.id),
      canShowEdit,
      size: 80,
      minSize: 80,
    }),
    {
      id: 'name',
      header: '試算名稱',
      accessorKey: 'name',
      accessorFn: (row) => displayDash(row.name),
      size: 200,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={displayDash(row.original.name)} />
      ),
    },
    {
      id: 'subtotalAmount',
      header: '未取整合計',
      accessorFn: (row) => formatCostEstimateDecimal(row.amountSummary?.subtotalAmount),
      size: 120,
      enableSorting: false,
      meta: { cellClassName: 'td_right' },
    },
    {
      id: 'totalAmount',
      header: '總額（TWD）',
      accessorFn: (row) => formatCostEstimateTotal(row.amountSummary?.totalAmount),
      size: 120,
      enableSorting: false,
      meta: { cellClassName: 'td_right' },
    },
    {
      id: 'roundingMode',
      header: '總額取整',
      accessorFn: (row) => formatCostEstimateRoundingMode(row.roundingMode),
      size: 100,
      enableSorting: false,
    },
    {
      id: 'lineCount',
      header: '明細數',
      accessorFn: (row) => (row.lines ?? []).length,
      size: 80,
      enableSorting: false,
    },
    {
      id: 'updatedAt',
      header: '更新時間',
      accessorFn: (row) => formatDateTimeOrDash(row.record?.updatedAt),
      size: 160,
    },
    {
      id: 'remark',
      header: '備註',
      accessorKey: 'remark',
      accessorFn: (row) => displayDash(row.remark),
      size: 180,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={displayDash(row.original.remark)} />
      ),
    },
  ];
}
